module.exports = __webpack_public_path__ + "img/personalized-service.e8f8b9c4.jpg";